import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from 'react-context-hook';

// Error handler
import useErrorHandler from '../utils/useErrorHandler';
import FlashMessage from '../utils/FlashMessage';

// Services

// Grommet

// Appt Components
import Box from '../components/simple/box/Box';
import H1 from '../components/simple/heading/H1';

// Appt Widgets

import { PDFObject } from 'react-pdfobject'
import ActionButton from '../components/compound/actionButton/ActionButton';

function PDFViewer(props) {
  const navigate = useNavigate();
  const { error, showError } = useErrorHandler(null);

  const [apiToken, setApiToken, deleteApiToken] = useStore();
  const [currentUser, setCurrentUser, deleteCurrentUser] = useStore({});
  const [currentOrgs, setCurrentOrgs, deleteCurrentOrgs] = useStore([]);
  const [activeOrg, setActiveOrg, deleteActiveOrg] = useStore();
  
  const location = useLocation()

  const url = decodeURIComponent(location?.search?.split('?url=')[1] || '');
  const [pdfData, setPdfData] = useState(null);

    

    useEffect(() => {


        
        const controller = new AbortController();
        let objectUrl;

        const fetchPdfData = async () => {
            try {
                const response = await fetch(url, { signal: controller.signal });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const blob = await response.blob();
                // Force the PDF type; the source may serve application/octet-stream.
                objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                setPdfData(objectUrl);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error fetching PDF:', error);
                }
            }
        }
        setPdfData(null);
        fetchPdfData();

        return () => {
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [url]);


  return (
    <>
      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'medium' }}
        round="small"
      >
        <Box direction="column" pad={{ horizontal: 'medium' }}>
          <H1 margin={{ top: 'small', bottom: 'small' }}>View Report </H1>
          {error && <FlashMessage message={error} />}
        </Box>
      </Box>


      <Box direction="row-responsive" gap="medium">
        <Box
          // background="white"
          direction="column"
          gap="medium"
          flex="grow"
          pad="none"
          round="small"
          width="100%"
        >
          <Box
            background="white"
            direction="column"
            gap="medium"
            flex="grow"
            pad="medium"
            round="small"
            width="100%"
          >
             <ActionButton
              margin={{ top: 'medium' }}
                onClick={() => navigate(-1)}
              label="< Back"
            />
            {pdfData && <PDFObject 
                url={pdfData} 
                height="700px"  
                pdfOpenParams={{ view: 'FitH', pagemode: 'none' }}
            />}
           
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PDFViewer;
